/**
 * Это модуль для авторизации
 * */

import axios from 'axios';
import api from '@/helpers/api';
import store from '@/store';

const state = {
    forms: {
        auth: {
            timer: {
                time: 0,
                timeDefault: 30,
                intervalId: [],
                smsBan: false,
                timeBan: 12,
            },
        },
    },
    user: {},
    isLoaded: false,
    isBanned: false,
    isBannedPermanent: false,
    setBanPermanentPhone: '',
    isNoSuccess: false,
    isNoSuccessSection: false,
    isGetRefreshToken: false,
    localStorage: {
        refresh_token: false,
        token: false,
    },
    client_id: false,
    client_secret: false,
    countRefresh: 0,
};

// getters
const getters = {
    refresh_token() {
        return store.state.auth.localStorage.refresh_token;
    },
    token() {
        return store.state.auth.localStorage.token;
    },
    needAuth() {
        return (!store.state.auth.user.id) && store.state.auth.isLoaded;
    },
};

const actions = {
    startTimer(context, data) {
        if ((state.forms.auth.timer.intervalId.length === 1 && state.forms.auth.timer.time === 0) || state.forms.auth.timer.intervalId.length > 1) {
            context.commit('clearInterval');
        }

        if (state.forms.auth.timer.intervalId.length === 0) {
            let time = state.forms.auth.timer.timeDefault;
            if (!!data && data.time) {
                time = data.time;
            }

            context.commit('setTimerTime', time);
            const timer = setInterval(() => {
                if (+state.forms.auth.timer.time > 0) {
                    context.commit('decrementTimerTime');
                } else {
                    context.commit('clearInterval');
                }
            }, 1000);
            context.commit('setInterval', timer);
        }
    },
    getCurrentUser(context) {
        return api.get('/users').then((response) => {
            if (response) {
                context.commit('setUser', { user: response });
                context.commit('refreshCountRefresh');
            } else {
                context.dispatch('clearUserAuthInfo', false);
            }
            context.commit('setLoaded', true);
            return response;
        }).catch(() => {});
    },
    checkLogin(context, data) {
        return api.post('/auth', {}, {
            login: data.login,
        }).then((response) => {
            if (typeof response === 'object') {
                if (data.secret) {
                    context.commit('setClient', response);
                }
                if (response.status === 'threshold' && response.threshold > 0) {
                    context.dispatch('startTimer', { time: +response.threshold }).then((r) => r);
                } else {
                    context.dispatch('startTimer', { time: context.state.forms.auth.timer.timeDefault }).then((r) => r);
                }
            }
        }).catch((r) => {
            throw r;
        });
    },
    checkRefreshToken(context) {
        return new Promise((resolve, reject) => {
            if (!context.state.isGetRefreshToken && context.state.localStorage.refresh_token && context.state.countRefresh < 2) {
                context.commit('setIsGetRefreshToken', true);
                context.commit('incrementCountRefresh');
                if (context.state.localStorage.refresh_token) {
                    const params = new FormData();
                    params.append('refresh_token', context.state.localStorage.refresh_token);
                    context.dispatch('getTokenRequest', { params, refresh_token: true }).then(
                        () => { context.commit('setIsGetRefreshToken', false); resolve(); },
                        (error) => { context.commit('setIsGetRefreshToken', false); reject(error); },
                    );
                } else {
                    context.commit('setIsGetRefreshToken', false);
                    resolve();
                }
            } else {
                resolve();
            }
        });
    },
    getToken(context, data) {
        return new Promise((resolve, reject) => {
            const params = new FormData();
            params.append('login', data.login);
            params.append('password', data.password);
            context.dispatch('getTokenRequest', { params }).then(
                () => { resolve(); },
                (error) => { reject(error); },
            );
        });
    },
    getTokenRequest(context, data) {
        return new Promise((resolve, reject) => {
            let path = `${process.env.VUE_APP_API_PATH}/auth/token`;
            if (data.refresh_token) {
                path = `${process.env.VUE_APP_API_PATH}/auth/refresh_token`;
            }
            axios.post(path, data.params, api.axiosConfig())
                .then((response) => {
                    if (response.data.error > 0) {
                        reject(response.data.error);
                    } else if (typeof response.data.result === 'object') {
                        if (response.data.result.refreshToken) {
                            const { user } = response.data.result;
                            context.commit('setLocalStorage', { key: 'refresh_token', value: response.data.result.refreshToken });
                            context.commit('setLocalStorage', { key: 'token', value: response.data.result.token });
                            if (user && !data.refresh_token) {
                                context.commit('setUser', response.data.result);
                                context.commit('setLoaded', true);
                                context.commit('clearInterval');
                            }
                            if (data.refresh_token) {
                                context.dispatch('getCurrentUser');
                            }
                            resolve();
                        }
                    } else {
                        reject();
                    }
                }).catch((response) => {
                    api.errorHandler(response).then(() => {
                        reject(response.data.error);
                    });
                });
        });
    },

    logout(context) {
        const id = context.state.user.id;
        context.commit('setUser', { user: {} });
        context.commit('setLoaded', true);
        context.commit('clearForms');
        context.commit('setLocalStorage', { key: 'token', value: false });
        context.commit('setLocalStorage', { key: 'refresh_token', value: false });
        window.scroll(0, 0);
        if (id) {
            context.commit('setBanPermanent', false);
            context.commit('setIsNoSuccess', false);
            context.commit('setIsNoSuccessSection', false);
            api.get('/auth/logout').then((r) => r);
        }
    },
    clearUserAuthInfo(context) {
        context.commit('setLocalStorage', { key: 'refresh_token', value: false });
        context.commit('setUser', { user: {} });
        context.commit('clearForms');
    },
};

const mutations = {
    setTimerTime(state, data) {
        state.forms.auth.timer.time = data;
    },
    decrementTimerTime(state) {
        if (+state.forms.auth.timer.time > 0) {
            state.forms.auth.timer.time -= 1;
        }
    },
    clearInterval(state) {
        Object.keys(state.forms.auth.timer.intervalId).forEach((i) => {
            clearInterval(state.forms.auth.timer.intervalId[i]);
        });
        state.forms.auth.timer.intervalId = [];
    },
    setInterval(state, data) {
        state.forms.auth.timer.intervalId.push(data);
    },
    setBan(state, data) {
        state.isBanned = data;
    },
    setBanPermanent(state, data) {
        state.isBannedPermanent = data;
    },
    setBanPermanentPhone(state, data) {
        state.setBanPermanentPhone = data;
    },
    setIsNoSuccess(state, data) {
        state.isNoSuccess = data;
    },
    setIsNoSuccessSection(state, data) {
        state.isNoSuccessSection = data;
    },
    setSmsBan(state) {
        state.forms.auth.timer.smsBan = true;
    },
    setIsGetRefreshToken(state, data) {
        state.isGetRefreshToken = data;
    },
    incrementCountRefresh(state) {
        state.countRefresh += 1;
    },
    refreshCountRefresh(state) {
        state.countRefresh = 0;
    },
    clearForms(state) {
        state.forms.auth.timer.time = 0;
        state.forms.auth.timer.smsBan = false;
        state.forms.auth.timer.timeBan = 12;
    },
    setUser(state, data) {
        if (typeof data === 'object' && data.user !== undefined) {
            state.user = data.user;
        }
    },
    setLoaded(state, data) {
        state.isLoaded = data;
    },
    setLocalStorage(state, data) {
        state.localStorage[data.key] = data.value;
    },
    setClient(state, data) {
        state.client_id = data.id;
        state.client_secret = data.secret;
    },
    mark(state, data) {
        state.user.marks[`rule_id_${data}`] = true;
    },
    setTechSettings(state, data) {
        state.user.tech_settings = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
